/* Own text truncation for the clamped product description.
 *
 * `-webkit-line-clamp` hides the overflow fine, but WebKit paints its ellipsis
 * ON TOP of the last glyph with this font (iOS: "matchend…" with the dots over
 * the "d") instead of shortening the text. So the text is shortened here until
 * text + "…" fits the clamp, and the native ellipsis is never needed. */

export const ELLIPSIS = '…';

/**
 * Longest prefix of `text` that, with the ellipsis appended, satisfies `fits`
 * (a layout test: candidate string → boolean). Returns `text` itself when the
 * whole text fits. Binary search: ~log2(length) layout probes.
 */
export const fitTextWithEllipsis = (text, fits) => {
  const full = typeof text === 'string' ? text : '';
  if (!full || fits(full)) return full;
  let lo = 0; // longest prefix length known to fit (with ellipsis)
  let hi = full.length; // shortest known not to fit
  const candidate = (n) => full.slice(0, n).trimEnd() + ELLIPSIS;
  while (hi - lo > 1) {
    const mid = (lo + hi) >> 1;
    if (fits(candidate(mid))) lo = mid; else hi = mid;
  }
  return candidate(lo);
};
